module.exports = __webpack_public_path__ + "img/721-9d8699.png";